import React from 'react';

const CAR_TYPE_OPTIONS = [
  { value: 'sedan', label: 'Sedan', icon: '🚗' },
  { value: 'suv', label: 'SUV', icon: '🚙' },
  { value: 'compact', label: 'Compacto', icon: '🚘' },
  { value: 'minivan', label: 'Minivan', icon: '🚐' },
  { value: 'truck', label: 'Caminhonete', icon: '🛻' },
  { value: 'kei', label: 'Kei Car', icon: '🔹' },
];

const BRAND_OPTIONS = ['Toyota', 'Honda', 'Nissan', 'Mazda', 'Subaru', 'Suzuki', 'Daihatsu', 'Mitsubishi', 'outra'];

export const QuestionarioCarrosStepTwo = ({ formData, handleChange }) => {
  return (
    <div className="space-y-4" data-testid="questionario-carros-step-2">
      <label className="block text-sm font-medium text-gray-700 mb-3">Que tipo de veículo você procura? *</label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {CAR_TYPE_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`relative flex flex-col items-center p-4 border-2 rounded-xl cursor-pointer transition ${
              formData.carType === option.value ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-200'
            }`}
            data-testid={`questionario-carros-car-type-option-${option.value}`}
          >
            <input
              type="radio"
              name="carType"
              value={option.value}
              checked={formData.carType === option.value}
              onChange={handleChange}
              className="sr-only"
              data-testid={`questionario-carros-car-type-radio-${option.value}`}
            />
            <span className="text-3xl mb-2">{option.icon}</span>
            <span className="font-medium text-gray-900">{option.label}</span>
          </label>
        ))}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Marca Preferida</label>
        <select
          name="brand"
          value={formData.brand}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          data-testid="questionario-carros-brand-select"
        >
          <option value="">Sem preferência</option>
          {BRAND_OPTIONS.map((brand) => (
            <option key={brand} value={brand}>
              {brand}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Modelos de Interesse</label>
        <input
          type="text"
          name="preferredModels"
          value={formData.preferredModels}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          placeholder="Ex: Corolla, Civic, Fit..."
          data-testid="questionario-carros-preferred-models-input"
        />
      </div>
    </div>
  );
};
